import { MdClose } from "react-icons/md";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ResetPassword, ResetPasswordForAd } from "../../../Redux/Action/LoginAction";
import { useNavigate } from "react-router";
import { RotateCcw, X } from "lucide-react";

export const ResetPassModal = ({ handelClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const token=localStorage.getItem("Admin");
  const userData=JSON.parse(token);
  const userRole=userData?.data?.role;

  const [isOpen, setIsOpen] = useState(true);
  const [oldpassword, setOldPassword] = useState("");
  const [newpassword, setNewPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [newpasswordType, setNewpasswordType] = useState("password");
  const [conpasswordType, setConpasswordType] = useState("password");
  const [oldpasswordType, setOldpasswordType] = useState("password");
  const [error, seterror] = useState("");

  useEffect(() => {
    if (newpassword === confirmpassword && passwordError) {
      setPasswordError("");
    }
  }, [newpassword, confirmpassword, passwordError]);

  useEffect(() => {
    if (oldpassword !== newpassword && error) {
      seterror("");
    }
  }, [oldpassword, newpassword, error]);

  const toggleNewPassword = (e) => {
    e?.preventDefault();
    if (newpasswordType === "password") {
      setNewpasswordType("text");
      return;
    }

    setNewpasswordType("password");
  };
  const toggleConfirmPassword = (e) => {
    e?.preventDefault();
    if (conpasswordType === "password") {
      setConpasswordType("text");
      return;
    }
    setConpasswordType("password");
  };
  const toggleOldPassword = (e) => {
    e?.preventDefault();
    if (oldpasswordType === "password") {
      setOldpasswordType("text");
      return;
    }
    setOldpasswordType("password");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      oldpassword,
      newpassword,
      confirmpassword,
    };
    if (newpassword !== confirmpassword) {
      setPasswordError(
        "The new password and the confirmed password must be the same."
      );
      return;
    }
    if (oldpassword === newpassword) {
      seterror("The new password must be different from the current password.");
      return;
    }
    if(userRole==="adaccountant" || userRole==="adsales" || userRole==="admanager" || userRole==="adsupport"){
      dispatch(ResetPasswordForAd(formData, navigate));
    }else{
      dispatch(ResetPassword(formData, navigate));
    }
    
  };

  return (
    <div
      className={`fixed right-0 top-0 h-full w-[500px] bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
        isOpen ? "translate-x-0" : "translate-x-full"
      } flex flex-col`}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-6 py-2 border-b border-gray-200 bg-[#FCDD00]">
        <div className="flex items-center">
          <h2 className="my-[7px] text-xl font-semibold text-gray-900">
            Change Password{" "}
          </h2>
        </div>
        <button
          onClick={handelClose}
          className="p-2 transition-colors duration-200 rounded-full hover:bg-white hover:bg-opacity-50"
        >
          <X className="w-5 h-5 text-gray-600" />
        </button>
      </div>
      {/* Body Content */}
      <div className="flex-1 p-6 space-y-6 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400">
        <form onSubmit={handleSubmit} id="resetPasswordForm">
          <div className="flex flex-col gap-5">
            <div className="relative flex flex-col gap-2">
              <span className="font-Poppins text-[15px] xl:text-base">
                Old Password
                <span className="text-[#fc0000]">*</span> :
              </span>
              <input
                className="py-[10px] xl:py-3 px-4 rounded-lg bg-[#FFFCE1] text-sm outline-[#FCDD00]"
                type={oldpasswordType}
                placeholder="Enter Old Password"
                id="corporateName"
                name="corporateName"
                value={oldpassword}
                onChange={(e) => {
                  const trimmedValue = e.target.value.trim();
                  setOldPassword(trimmedValue);
                }}
                required
                autoComplete="off"
                maxLength={50}
              />
              <div className="absolute right-4 top-[35px] xl:top-[41px] z-10 bg-[#FFFCE1] py-1">
                <button onClick={toggleOldPassword}>
                  {oldpasswordType === "password" ? (
                    // <img src={eyeopen} alt="new" />
                    <BsEye />
                  ) : (
                    // <img src={eyeclose} alt="new" />
                    <BsEyeSlash />
                  )}
                </button>
              </div>
            </div>
            <div className="relative flex flex-col gap-2">
              <span className="font-Poppins text-[15px] xl:text-base">
                New Password
                <span className="text-[#fc0000]">*</span> :
              </span>
              <input
                className="py-[10px] xl:py-3 px-4 rounded-lg bg-[#FFFCE1] text-sm outline-[#FCDD00]"
                type={newpasswordType}
                placeholder="Enter New Password"
                value={newpassword}
                onChange={(e) => {
                  const trimmedValue = e.target.value.trim();
                  setNewPassword(trimmedValue);
                }}
                required
                autoComplete="off"
              />
              <div className="absolute right-4 top-[35px] xl:top-[41px] z-10 bg-[#FFFCE1] py-1">
                <button onClick={toggleNewPassword}>
                  {newpasswordType === "password" ? (
                    // <img src={eyeopen} alt="new" />
                    <BsEye />
                  ) : (
                    // <img src={eyeclose} alt="new" />
                    <BsEyeSlash />
                  )}
                </button>
              </div>
            </div>
            <div className="relative flex flex-col gap-2">
              <span className="font-Poppins text-[15px] xl:text-base">
                Confirm Password
                <span className="text-[#fc0000]">*</span> :
              </span>
              <input
                className="py-[10px] xl:py-3 px-4 rounded-lg bg-[#FFFCE1] text-sm outline-[#FCDD00]"
                type={conpasswordType}
                placeholder="Enter Confirm Password"
                id="email"
                name="email"
                value={confirmpassword}
                onChange={(e) => {
                  const trimmedValue = e.target.value.trim();
                  setConfirmPassword(trimmedValue);
                }}
                required
                autoComplete="off"
              />
              <div className="absolute right-4 top-[35px] xl:top-[41px] z-10 bg-[#FFFCE1] py-1">
                <button onClick={toggleConfirmPassword}>
                  {conpasswordType === "password" ? (
                    // <img src={eyeopen} alt="new" />
                    <BsEye />
                  ) : (
                    // <img src={eyeclose} alt="new" />
                    <BsEyeSlash />
                  )}
                </button>
              </div>
            </div>
            {passwordError && (
              <p className="text-center text-red-500">{passwordError}</p>
            )}
            {error && <p className="text-center text-red-500">{error}</p>}
            {/* <div className="flex justify-end">
                <button
                  // onSubmit={handleSubmit}
                  type="submit"
                  className="bg-[#FCDD00] text-[#1A1A1A]  px-5 py-2 rounded-lg font-Poppins text-lg flex items-center justify-center gap-1 cursor-pointer hover:scale-105 outline-none"
                >
                  Update Password
                </button>
              </div> */}
          </div>
        </form>
      </div>
      {/* Footer Actions */}
      <div className="flex flex-row gap-3 p-6 border-t border-gray-200 bg-gray-50">
        {userRole==="adaccountant" || userRole==="adsales" || userRole==="admanager" || userRole==="adsupport" ? (
          <button
          id="resetPasswordRole"
          type="submit"
          form="resetPasswordForm"
          className="w-full bg-[#FCDD00] text-black py-3 px-4 rounded-lg hover:bg-[#FCDD00] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200 font-medium"
        >
          Update Password
        </button>
        ) : (
          <button
          id="resetPassword"
          type="submit"
          form="resetPasswordForm"
          className="w-full bg-[#FCDD00] text-black py-3 px-4 rounded-lg hover:bg-[#FCDD00] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200 font-medium"
        >
          Update Password
        </button>
        )}
          <button
          onClick={handelClose}
          className="flex items-center justify-center w-full px-4 py-3 font-medium text-gray-700 transition-colors duration-200 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
        >
          Close
        </button>
      </div>
    </div>
  );
};
